import React, { useState } from 'react';
import classnames from 'classnames';
import Icon from 'utils/components/icon';
import { SpotSelectorItems } from './spot-selector-items';
import { Dispatch } from 'redux';
import { setExpanded, toggleSpotSelector } from '../../../../../spot-selector/spotSelectorSlice';
import { connect } from 'react-redux';
import { useTypedSelector } from 'state';

interface SpotSelectorProps {
  spotId: string;
  ssoEnabled: boolean;
  hasDropdown: boolean;
}

interface DispatchProps {
  toggleSpotSelector: () => void;
  closeSpotSelector: () => void;
}

export const SpotSelector: React.FC<SpotSelectorProps & DispatchProps> = ({
  spotId,
  ssoEnabled,
  hasDropdown,
  toggleSpotSelector,
  closeSpotSelector
}) => {
  const [searchedSpot, setSearchedSpot] = useState<string>('');
  const { isExpanded, spots, spotName, selectedSpotId } = useTypedSelector(
    state => state.spotSelector
  );

  let name = spotName;
  if (!name) {
    const index = spots.findIndex(spot => spot.id === selectedSpotId);
    name = 'Add new Site';
    if (index > -1) {
      name = spots[index].name;
    }
  }

  const handleClose = () => {
    setSearchedSpot('');
    closeSpotSelector();
  };

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchedSpot(event.target.value.toLowerCase());
  };

  const toggleDropdown = () => {
    toggleSpotSelector();
  };

  const containerClassName = classnames('spot-selector', {
    'has-dropdown': hasDropdown
  });

  const headerClassName = classnames('spot-name-container', {
    'is-open': isExpanded
  });

  const backdropClass = classnames('backdrop', {
    'is-open': isExpanded
  });

  return (
    <div className={containerClassName}>
      <div className={headerClassName} onClick={hasDropdown ? toggleDropdown : () => {}}>
        <span className="name">{name}</span>
        {ssoEnabled && <Icon name="sso_badge" className="sso-badge" />}
        {hasDropdown && <Icon name="caret-down" className="toggle-more-caret" />}
      </div>
      {isExpanded ? (
        <SpotSelectorItems
          searchedSpot={searchedSpot}
          spots={spots ?? []}
          spotId={spotId}
          handleClose={handleClose}
          onSearchChange={onSearchChange}
        />
      ) : null}
      <div data-testid="dropdown-backdrop" className={backdropClass} onClick={handleClose} />
    </div>
  );
};

SpotSelector.displayName = 'SpotSelector';

function mapDispatchToProp(dispatch: Dispatch) {
  return {
    toggleSpotSelector: () => dispatch(toggleSpotSelector()),
    closeSpotSelector: () => dispatch(setExpanded(false))
  };
}

export default connect(undefined, mapDispatchToProp)(SpotSelector);
